import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { ActivatedRoute, Data, Router } from "@angular/router";
import { LookupService } from "../../../services/lookups/lookup.service";
import { PVService } from "../../../services/nonanon/pv.service";
import { VehicleService } from "../../../services/nonanon/vehicle/vehicle.service";
import { AuthService } from "../../../services/auth/auth.service";
import { NotificationComponent } from "../../shared/notification.component";
import { PersonInfoService } from '../../../services/nonanon/person/person-info.service';
import { VehicleComponent } from './vehicle.component';
import { tokenNotExpired } from "angular2-jwt";


@Component({
  selector: 'app-vehicle-search-form',
  templateUrl: './vehicle-search-form.component.html'
})
export class VehicleSearchFormComponent implements OnInit, OnDestroy {
  frm: FormGroup;
  @ViewChild('notification') notificationComponent: NotificationComponent;

  private errorMessage: string = null;

  hasErrors() {
    return this.errorMessage != null;
  }
  getErrorMessage() {
    return this.hasErrors() ? this.errorMessage : "";
  }

  onProvincesLoaded: Subscription;
  onColorsLoaded: Subscription;
  onFormValueChanged: Subscription;
  onPersonInfoChanged: Subscription;
  onPersonInfoChangedByAccessCode: Subscription;
  onVehicleSearchResultsChanged: Subscription;

  colors: any[];
  provinces: any[];

  constructor(private pvService: PVService, private lookupService: LookupService,
    private route: ActivatedRoute, private vehicleService: VehicleService, private vehicleComponent: VehicleComponent,
    private authService: AuthService, private personInfoService: PersonInfoService, private router: Router
  ) { }


  loading: boolean = false;

  canSearchByVehiclePlateNumber: boolean = false;
  canSearchByVIN: boolean = false;
  canSearchByDL: boolean;
  canAccessDLSearch: boolean;
  canAccessVehicleSearch: boolean;
  canAccessCodeSearch: boolean;


  atLeastOneValuePopulated(form: FormGroup): { [s: string]: boolean } {
    if ((form.value.referenceNumber != null || form.value.referenceNumber != "") &&
      (form.value.plateNumber == null || form.value.plateNumber == "") &&
      (form.value.vin == null || form.value.vin == "") &&
      (form.value.dlNumber == null || form.value.dlNumber == "") &&
      (form.value.accessCode == null || form.value.accessCode == "")) {
      return { 'atLeastOneValuePopulated': true };
    }

    return null;
  }

  ngOnInit() {

    this.colors = [];
    this.provinces = [];

    this.canSearchByVehiclePlateNumber = this.authService.getUser().canSearchByVehiclePlateNumber;
    this.canSearchByVIN = this.authService.getUser().canSearchByVIN;
    this.canSearchByDL = this.authService.getUser().canSearchByDL;
    this.canAccessDLSearch = this.authService.getUser().canAccessDLSearch;
    this.canAccessVehicleSearch = this.authService.getUser().canAccessVehicleSearch;
    this.canAccessCodeSearch = this.authService.getUser().canAccessCodeSearch;

    this.onProvincesLoaded = this.route.data
      .subscribe(
        (data: Data) => {
          this.provinces = data['provinces'];
        });

    this.onColorsLoaded = this.route.data
      .subscribe(
        (data: Data) => {
          this.colors = data['colors'];
        });

    this.frm = new FormGroup(
      {
        'referenceNumber': new FormControl(null, [
          Validators.required
        ]),

        'provinceId': new FormControl(67), //this.lookupService.getDefaultProvinceId(), default value Yukon teritory

        'plateNumber': new FormControl(null, [
          Validators.pattern('^[A-Za-z0-9 ]+$')
        ]),

        'vin': new FormControl(null, [
          Validators.pattern('^[A-Za-z0-9 ]+$')
        ]),

        'dlNumber': new FormControl(null, [
          Validators.pattern('^[A-Za-z0-9 ]+$')
        ]),

        'accessCode': new FormControl(null, [
          Validators.pattern('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')
        ])

      }, this.atLeastOneValuePopulated
    );

    // validate all form fields (for 'clear' form functionallity)
    this.validateAllFormFields(this.frm);

    this.onFormValueChanged = this.frm.valueChanges.subscribe(data => {
      this.notificationComponent.clear();
    })


    // DISABLE AND ENABLE INPUT FIELDS DEPENDENT ON TYPE OF SEARCH (VEHICLE/DRIVER)

    this.frm.get('dlNumber').valueChanges.subscribe(
      value => {
        if (value != '') {
          this.frm.get('plateNumber').disable({ emitEvent: false });
          this.frm.get('vin').disable({ emitEvent: false });
          this.frm.get('accessCode').disable({ emitEvent: false });
        } else {
          this.frm.get('plateNumber').enable({ emitEvent: false });
          this.frm.get('vin').enable({ emitEvent: false });
          this.frm.get('accessCode').enable({ emitEvent: false });
        }
      });

    this.frm.get('plateNumber').valueChanges.subscribe(
      value => {
        if (value != '') {
          this.frm.get('dlNumber').disable({ emitEvent: false });
          this.frm.get('vin').disable({ emitEvent: false });
          this.frm.get('accessCode').disable({ emitEvent: false });
        }
        //else if (value == '' && this.frm.get('vin').value != '') {  |
        //  this.frm.get('dlNumber').disable({ emitEvent: false });   |=> used if two fields plate&vin should be active while driver is inactive and vice versa
        //}                                                           |
        else {
          this.frm.get('dlNumber').enable({ emitEvent: false });
          this.frm.get('vin').enable({ emitEvent: false });
          this.frm.get('accessCode').enable({ emitEvent: false });
        }
      });

    this.frm.get('vin').valueChanges.subscribe(
      value => {
        if (value != '') {
          this.frm.get('plateNumber').disable({ emitEvent: false });
          this.frm.get('dlNumber').disable({ emitEvent: false });
          this.frm.get('accessCode').disable({ emitEvent: false });
        }else {
          this.frm.get('plateNumber').enable({ emitEvent: false });
          this.frm.get('dlNumber').enable({ emitEvent: false });
          this.frm.get('accessCode').enable({ emitEvent: false });
        }
      });

    this.frm.get('accessCode').valueChanges.subscribe(
      value => {
        if (value != '') {
          this.frm.get('plateNumber').disable({ emitEvent: false });
          this.frm.get('vin').disable({ emitEvent: false });
          this.frm.get('dlNumber').disable({ emitEvent: false });
        } else {
          this.frm.get('plateNumber').enable({ emitEvent: false });
          this.frm.get('vin').enable({ emitEvent: false });
          this.frm.get('dlNumber').enable({ emitEvent: false });
        }
      });

    // END


    this.onVehicleSearchResultsChanged = this.vehicleService.vehicleSearchResultsChanged
      .subscribe(
        () => {
          if (this.vehicleService.hasErrors()) {
            this.errorMessage = this.vehicleService.getErrorMessage();
            this.notificationComponent.animateErrorAction(this.errorMessage);
          } else {
            this.errorMessage = null;
            this.notificationComponent.animate(this.vehicleService.getResponseInfo());
          }

          this.loading = false;
        });

    this.onPersonInfoChanged = this.personInfoService.personInfoChanged
      .subscribe(
        () => {
          if (this.personInfoService.hasErrors()) {
            this.errorMessage = this.personInfoService.getErrorMessage();
            this.notificationComponent.animateErrorAction(this.errorMessage);
          } else {
            this.errorMessage = null;
            this.notificationComponent.animate(this.personInfoService.getResponseInfo());
          }

          this.loading = false;
        });

    this.onPersonInfoChangedByAccessCode = this.personInfoService.personInfoChangedByAccessCode
      .subscribe(
        () => {
          if (this.personInfoService.hasErrors()) {
            this.errorMessage = this.personInfoService.getErrorMessage();
            this.notificationComponent.animateErrorAction(this.errorMessage);
          } else {
            this.errorMessage = null;
            this.notificationComponent.animate(this.personInfoService.getResponseInfoByAccessCode());
          }

          this.loading = false;
        });
  }

  ngOnDestroy() {
    this.onVehicleSearchResultsChanged.unsubscribe();
    this.onProvincesLoaded.unsubscribe();
    this.onColorsLoaded.unsubscribe();
    this.onFormValueChanged.unsubscribe();
    this.onPersonInfoChanged.unsubscribe();
  }

  searchById(id: number) {
    this.pvService.clearSelectedVehicle();

    this.loading = true;

    this.vehicleService.getById(id, this.authService.getUser().appUserId);
  }

  submitForm() {

    if (tokenNotExpired()) {
      this.pvService.clearSelectedVehicle();
      this.vehicleService.clearSearchResult();

      if (this.frm.invalid) { return false; }
      this.loading = true;

      // SEARCH FOR DRIVER OR VEHICLE DEPEND ON INPUT PARAMETERS

      this.vehicleComponent.isDriverSearch = false;
      this.vehicleComponent.isVehicleSearch = false;
      this.vehicleComponent.isAccessCodeSearch = false;
      this.vehicleComponent.searchHasResult = false;

      // PERSON SEARCH
      if (

        (this.frm.get('plateNumber').value == null || this.frm.get('plateNumber').value == "") &&
        (this.frm.get('vin').value == null || this.frm.get('vin').value == "") &&
        (this.frm.get('accessCode').value == null || this.frm.get('accessCode').value == "") &&
        (this.frm.get('dlNumber').value != null || this.frm.get('dlNumber').value != "")

      ) {

        this.vehicleComponent.isDriverSearch = true;
        this.personInfoService.loadPersonInfo(null, this.frm.value.referenceNumber, this.frm.value.dlNumber, 1, "", this.authService.getUser().email, this.authService.getUser().appUserId);
        this.frm.controls['referenceNumber'].reset();
        this.validateAllFormFields(this.frm);

      }

      // VEHICLE SEARCH
      else if (

        ((this.frm.get('plateNumber').value != null || this.frm.get('plateNumber').value != "") ||
        (this.frm.get('vin').value != null || this.frm.get('vin').value != "")) &&
        (this.frm.get('accessCode').value == null || this.frm.get('accessCode').value == "") &&
        (this.frm.get('dlNumber').value == null || this.frm.get('dlNumber').value == "")

      ) {

        this.vehicleComponent.isVehicleSearch = true;

        //var plateNumberNoSpace;
        //var vinNoSpace;

        // remove spaces between characters for vin and plate form field
        //if (this.frm.value.plateNumber == null || this.frm.value.plateNumber == "") {
        //  plateNumberNoSpace = "";
        //} else {
        //  plateNumberNoSpace = this.frm.value.plateNumber.split(' ').join('');
        //}

        //if (this.frm.value.vin == null || this.frm.value.vin == "") {
        //  vinNoSpace = "";
        //} else {
        //  vinNoSpace = this.frm.value.vin.split(' ').join('');
        //}
        //end

        this.vehicleService.search(this.frm.value.plateNumber, this.frm.value.referenceNumber, this.frm.value.provinceId, this.frm.value.vin, this.authService.getUser().appUserId);
        this.frm.controls['referenceNumber'].reset();
        this.validateAllFormFields(this.frm);
      }

      // PERSON SEARCH BY ACCESS CODE
      else {
        this.vehicleComponent.isAccessCodeSearch = true;

        this.personInfoService.loadPersonInfoByAccessCode(this.frm.value.referenceNumber, this.frm.value.accessCode, 1, "", this.authService.getUser().email, this.authService.getUser().appUserId);
        this.frm.controls['referenceNumber'].reset();
        this.validateAllFormFields(this.frm);
      }
    } else {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    

  }

  resetForm() {
    this.frm.reset({
      referenceNumber: "",
      plateNumber: "",
      provinceId: this.lookupService.getDefaultProvinceId(),
      colorId: null,
      make: "",
      model: "",
      vin: "",
      dlNumber: "",
      accessCode: ""
    });


    this.pvService.clearSelectedVehicle();
    this.vehicleService.clearSearchResult();

    this.loading = false;

    //clear search results component
    this.vehicleComponent.isDriverSearch = false;
    this.vehicleComponent.isVehicleSearch = false;
    this.vehicleComponent.isAccessCodeSearch = false;
    this.vehicleComponent.searchHasResult = false;

    //on clear search fields, focus on reference# field (mark required as initially)
    this.frm.get('referenceNumber').markAsTouched();

    console.log(this.frm.controls["vin"]);
  } 

  // VALIDATE SEARCH (IF REQUIRED) FORM ON PAGE LOAD

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => { 
      const control = formGroup.get(field);
      if (control instanceof FormControl) {          
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);            
      }
    });
  }

}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/nonanon/vehicle/vehicle-search-form.component.ts